import React from 'react';
import {PopoverButton, IPopoverButtonProps} from '@techsmith/tsc-cloud-style-guide';

const TestablePopoverButton: React.FC<ITestablePopoverButtonProps> = ({children, ...otherProps}) => (
   <PopoverButton
      popoverMenu={children}
      {...otherProps}
   />
);

export default TestablePopoverButton;

interface ITestablePopoverButtonProps extends Omit<IPopoverButtonProps, 'popoverMenu'> {
   children?: React.ReactNode;
}
